import { lazy } from "react"

import Login from "../../app/auth/login"
import Signup from "../../app/auth/sign-up"
const ReminderLogin = lazy(() => import("../../app/auth/reminder-login"))
const ExternalPriceEstimate = lazy(
  () => import("@features/price-estimate/external-price-estimate")
)
const ExternalFaqs = lazy(() => import("@features/faqs/external-faqs"))
const ResetPassword = lazy(() => import("../../app/auth/reset-password"))
const Terms = lazy(() => import("@features/terms/terms"))
const UploadOrderDocs = lazy(
  () => import("@features/admin/process-orders/upload-docs")
)
const VerifyPayment = lazy(
  () => import("@features/payments/verify-payment")
)

const publicPages = [
  {
    index: true,
    Component: Login,
  },
  {
    path: "signup",
    Component: Signup,
  },
  {
    path: "rmdr",
    Component: ReminderLogin,
  },
  {
    path: "reset-password",
    Component: ResetPassword,
  },
  {
    path: "terms",
    Component: Terms,
  },
  {
    path: "pricing",
    Component: ExternalPriceEstimate,
  },
  {
    path: "frequently-asked-questions",
    Component: ExternalFaqs,
  },
  {
    path: "upload-docs",
    Component: UploadOrderDocs,
  },
  {
    path: "payments/verify-payment",
    Component: VerifyPayment,
  },
]

export default publicPages
